<template>
  <div>
    <v-layout class="mt-2 mb-2">
      <v-flex xs6>
        <BuscaSimplesApi label="Buscar" :disabled="acao != ''" route="merenda/tipo-movimento-deposito-escola" :fieldSearch="buscarSelect"
          @found="encontrado" ref="buscaSimpleApi">
          <template slot-scope="propSlot">
            <span>{{ propSlot.item.descricaotipomovimento }}</span>
          </template>
        </BuscaSimplesApi>
      </v-flex>
      <v-flex xs4 class="ml-3">
        <Select :options="buscaOptions" v-model="buscarSelect" label="" @change="selectBuscaChange" />
      </v-flex>
    </v-layout>

    <v-alert type="error" :value="($v.$invalid && $v.$dirty) || msgArrayError.length > 0" style="color: white;">
      <div v-if="$v.$invalid && $v.$dirty"> Preencha os campos corretamente.</div>
      <div v-if="msgArrayError.length > 0">
        <ul v-for="error of msgArrayError" :key="error.key">
          <li>{{ error }}</li>
        </ul>
      </div>
    </v-alert>

    <FormBasico :acao="acao" :id="form.identificadortipomovimento" :novo="novoTipoDoMovimento" :editar="editarTipoDoMovimento"
      :excluir="excluirTipoDoMovimento" :cancelar="cancelarTipoDoMovimento" :submit="onSubmit">
      <v-tabs>
        <v-tabs-slider color="#fff"></v-tabs-slider>
        <v-tab @click="tabelaTipoDoMovimentoDoDepositoNaEscola">
          <v-icon left color="#757575">view_list</v-icon>
        </v-tab>
      </v-tabs>
      <v-card>
        <v-card-text>
          <Input type="text" label="Código do Tipo do Movimento" v-model="form.identificadortipomovimento" disabled />
          <Input type="text" label="Descrição do Tipo do Movimento" ref="focusCampo" v-model="form.descricaotipomovimento"
            :disabled="acao == '' || acao == 'excluir'" :v="$v.form.descricaotipomovimento" />
          <Validator label="Status do Tipo de Movimento" :v="$v.form.indicadorstatustipomovimento">
            <Radio  v-model="form.indicadorstatustipomovimento" :disabled="acao == ''" val="E"  label="Entrada"/>
            <Radio  v-model="form.indicadorstatustipomovimento" :disabled="acao == ''" val="S"  label="Saída"/>
            <Radio  v-model="form.indicadorstatustipomovimento" :disabled="acao == ''" val="R"  label="Rejeição"/>
          </Validator>
        </v-card-text>
      </v-card>
    </FormBasico>

    <v-snackbar v-model="snackbar" bottom left :timeout="4000" height="10px" rounded="0"  >
        <div class="d-flex justify-space-between align-center">
           <span> {{ submitText }}</span>
            <v-btn class="text-right" variant="text"  icon  @click="snackbar = false" > <v-icon>close</v-icon> </v-btn>
        </div>
    </v-snackbar>
  </div>
</template>

<script>
import BuscaSimplesApi from '@/components/BuscaSimplesApi';
import { required, maxLength } from 'vuelidate/lib/validators';
import { RepositoryFactory } from "@/repositories/RepositoryFactory";

const TipoMovimentoDepositoEscolaRepository = RepositoryFactory.get("tipoMovimentoDeposito")

const setFormInicial = () => ({
  identificadortipomovimento: '',
  descricaotipomovimento: '',
  indicadorstatustipomovimento: ''
});

export default {
  name: 'TipoMovimentoDepositoEscola',
  components: { BuscaSimplesApi },
  data() {
    return {
      acao: '',
      form: setFormInicial(),
      submitText: '',
      snackbar: false,
      msgArrayError: [],
      buscarSelect: 'descricaotipomovimento',
      buscaOptions: [
        { value: 'identificadortipomovimento', text: 'Código' },
        { value: 'descricaotipomovimento', text: 'Tipo do movimento' },
      ],
      formUltimo: {},
    };
  },
  validations: {
    form: {
      descricaotipomovimento: { required, maxLength: maxLength(100) },
      indicadorstatustipomovimento: { required },
    },

  },

  mounted() {
    this.$Progress.finish();
  },
  methods: {
    tabelaTipoDoMovimentoDoDepositoNaEscola() {
      this.$root.$router.push({
        name: 'tabelas',
        params: {
          titulo: 'Tipo do Movimento do Depósito na Escola / Listar',
          rota_api: 'merenda/tipo-movimento-deposito-escola/tabela',
          headers: [{ text: 'Identificador', value: 'identificadortipomovimento', sortable: false },
          { text: 'Título', value: 'descricaotipomovimento', sortable: false },
          { text: 'Status do Movimento', value: 'indicadorstatustipomovimento', sortable: false },
          ],
        },
      });
    },
    novoTipoDoMovimento() {
      this.acao = 'novo';
      this.form = setFormInicial();
      this.$v.$reset();
      setTimeout(() => this.$refs.focusCampo.$refs.input.focus(), 200);
    },
    editarTipoDoMovimento() {
      this.acao = 'editar';
    },
    cancelarTipoDoMovimento() {
      if (this.acao == 'novo') {
        this.form = setFormInicial();
      } else {
        this.form = { ...this.formUltimo };
      }
      this.acao = '';
      this.msgArrayError = [];
      this.$v.$reset();
    },
    async excluirTipoDoMovimento() {
      this.acao = 'excluir';

      const confirmar = await this.$sgal({
        title: 'Tem certeza?',
        text: 'Deseja realmente excluir este tipo do movimento do depósito na escola?',
        type: 'warning',
        buttons: [
          { text: 'Sim, excluir', color: 'red', response: true },
          { text: 'Não, cancelar', color: 'grey', response: false },
        ],
      });

      if (confirmar) {
        try {
          const { data } = await TipoMovimentoDepositoEscolaRepository.deletarTipoMovimentoDeposito(this.form.identificadortipomovimento);

          this.submitText = data.message;
          this.snackbar = true;
          this.form = setFormInicial();
          this.msgArrayError = [];
        } catch (error) {
          const ntfExcluir = await this.$sgal({
            title: 'Não foi possível!',
            text: error.response.data.errorMessage[0],
            type: 'notification',
          });
        }
      }

      this.acao = '';
    },

    async onSubmit() {
      this.$v.$touch();

      if (this.$v.$invalid) return;

      try {
        const { data } = await TipoMovimentoDepositoEscolaRepository[this.acao === 'novo' ? 'criarTipoMovimentoDeposito' : 'editarTipoMovimentoDeposito'](this.form);

        this.acao = '';
        this.submitText = data.message;
        this.snackbar = true;
        this.msgArrayError = [];
        this.form = { ...data.results };
        this.formUltimo = { ...this.form };

      } catch (error) {
        if (error.response.data.status == 'ERROR_BUSINESS_RULE') { this.msgArrayError = error.response.data.errorMessage; }
        if (window.scrollY >= 250) { window.scrollTo({ top: 0, behavior: 'smooth' }); }
      }

      this.$v.$reset();
    },
    encontrado(dados) {
      this.form = setFormInicial();
      this.form = { ...dados };
      this.formUltimo = { ...dados };
      this.$refs.buscaSimpleApi.lista = [];
    },
    selectBuscaChange() {
      this.$refs.buscaSimpleApi.busca = '';
    },
  },
};
</script>

<style></style>
